// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1HYwv","upload":"Small_upload__12F6w","imageWrap":"Small_imageWrap__2di2D","removeBtn":"Small_removeBtn__wjMTJ"};